import styled from '@emotion/styled';
import { Flex, css } from 'theme-ui';
import pxToRem from '../../utils/pixelsToRem';

export const RegionBox = styled(Flex)(
  css({
    width: '100%',
    height: ['120px', '160px'],
    justifyContent: 'center',
    alignItems: 'center',
    p: '16px',
    color: 'white',
    boxShadow: 'inset 0 0 0 1000px rgb(0 0 0 / 40%)',
    cursor: 'pointer',

    '&:hover': {
      background: 'focus',
      color: 'text',
      boxShadow: 'none',
    },
  }),
  ({ $image }) =>
    css({
      background: `url(${$image})`,
      backgroundSize: 'cover',
    }),
);

export const RegionBoxTitle = styled.h2(
  css({
    width: '100%',
    textTransform: 'uppercase',
    fontSize: pxToRem(18),
    fontWeight: '600',
    letterSpacing: '0.01em',
    textAlign: 'center',
  }),
);
